/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/higgins.scss';

// Here we only need to load #Higgins specifc scripts, the rest come from the Marmalade theme
document.addEventListener('DOMContentLoaded', () => {
  // Import the blocks
  import('scripts/sections/map');

  // // Add the src and a condition required to load the script
  // window.HigginsScriptsLoaded = ScriptLoader({
  //   './sections/map': document.querySelector('#Higgins .js-map'),
  // }, 'higgins-scripts-loaded');
});
window.addEventListener('higgins-scripts-loaded', () => {
  console.log("%chiggins", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded');
});